export const JOB_CREATE_REQUEST = 'job/create-request'
export const JOB_CREATE_SUCCESS = 'job/create-success'
export const JOB_CREATE_FAILED = 'job/create-failed'
